import { Component } from 'react'
import Select from "react-select";
import { useField } from 'formik'
import EditEventFormTypeWrapper from './EditEventFormTypeWrapper';
import CurrentName from '../general/CurrentName';

const FormSelect = ({name, options, labelKey = 'name', valueKey = 'id', onMenuClose}) => {
    const [field, meta, helpers] = useField(name)

    return (
        <Select
            name={name}
            value={field.value}
            options={options}
            getOptionLabel ={(option) => option[labelKey]}
            getOptionValue ={(option) => option[valueKey]}
            onChange={(value) => helpers.setValue(value.id)}
            onBlur={() => helpers.setTouched(true)}
            onMenuClose={onMenuClose}
        />
    )
}

class EditEventFormSingleType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false
        }

        this.setEditing = this.setEditing.bind(this)
    }

    setEditing(newValue) {
        this.setState({
            editing: newValue
        })
    }

    getOptions() {
        const { keyId, keyName, settings } = this.props 
        const options = []

        settings.order.map(id => {
            const item = settings.items[id] 

            options.push({
                name: item[keyName],
                id: item[keyId]
            })
        })

        return options
    }

    getValueName(id) {
        const { keyName, settings } = this.props 

        return settings.items.hasOwnProperty(id) ? settings.items[id][keyName] : 'undefined'
    }

    render()  {
        const { headline, fieldName, currValue, formValue, activeField, setActiveField } = this.props
        const editing = (activeField === fieldName);
        // const { editing } = this.state
        const options = this.getOptions()
        const currName = this.getValueName(currValue) 
        const formName = this.getValueName(formValue)

        return (
            <EditEventFormTypeWrapper headline={headline}>
                <div className='event-single-type-selection cursor-pointer'>
                    {!editing
                    ?
                        <p onClick={()=>setActiveField(fieldName)}>
                            <CurrentName
                                formValue={formValue}
                                currValue={currValue}
                                formName={formName}
                                currName={currName}
                            />
                        </p>
                    :
                        <FormSelect
                            name={fieldName}
                            options={options}
                            onMenuClose={()=>setActiveField('')}
                        />
                    }
                </div>
            </EditEventFormTypeWrapper>
        )
    }
}

export default EditEventFormSingleType